import React from 'react'
import { atom, useSetRecoilState, useRecoilValue } from 'recoil'

export const pageHeaderState = atom<{
  title?: string | React.ReactNode
  content?: string | React.ReactNode
  contentRight?: string | React.ReactNode
}>({
  key: 'pageHeaderState',
  default: {
    content: '',
    contentRight: '',
  },
})

export function usePageHeader() {
  return useRecoilValue(pageHeaderState)
}

export function useSetPageHeaderContent(content: string | React.ReactNode) {
  const setHeader = useSetRecoilState(pageHeaderState)

  React.useLayoutEffect(() => {
    setHeader(prev => ({ ...prev, content }))

    return function cleanup() {
      setHeader({ content: '' })
    }
  }, [content]) // eslint-disable-line
}

export function useSetPageHeaderContentRight(contentRight: string | React.ReactNode) {
  const setHeader = useSetRecoilState(pageHeaderState)

  React.useLayoutEffect(() => {
    setHeader(prev => ({ ...prev, contentRight }))

    return function cleanup() {
      setHeader({ contentRight: '' })
    }
  }, [contentRight]) // eslint-disable-line
}

export function PageHeader({ children }: any) {
  useSetPageHeaderContent(children)
  useSetPageHeaderContentRight(children)

  return <></>
}
